module.exports = __webpack_public_path__ + "static/media/tier-1.461cb415.jpg";